// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1enGg","label":"styles_label__1WCTm"};